<template>
  <div class="row header-tab">
    <div class="row">
      <div
        class="tab-item" 
        :class="{'tab-item-active': index === activeIndex}" 
        v-for="(item, index) in tabs" 
        :key="index"
        @click="onTabClick(item, index)"
      >
        {{item}}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0
    };
  },
  props: {
    tabs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onTabClick(item, index) {
      this.activeIndex = index;
      this.$emit('change', {
        item,
        index
      });
    }
  },
  mounted() {
    
  }
};
</script>

<style lang="scss" scoped>
.header-tab {
  justify-content: space-between;
  padding: 0 24px;
  height: 44px;
  line-height: 44px;
  width: 100%;
  box-shadow: inset 0px -1px 0px 0px#f7f7fa;
  background-color: #ffffff;
  font-size: 14px;
  .tab-item {
    margin-right: 32px;
    color: #747990;
    cursor: pointer;
    &:hover {
      color: #171f46;
    }
  }
  .tab-item-active {
    position: relative;
    color: #171f46;
  }
  .tab-item-active::after {
    content: "";
    position: absolute;
    top: 35px;
    left: 50%;
    transform: translateX(-50%);
    width: 14px;
    height: 3px;
    background-color: #171f46;
  }
}
</style>


